import React from 'react';
import clsx from "clsx";
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import styled from "styled-components";
import { useIntl } from 'react-intl';
import { Form, Input } from 'antd';
import Button from '../../components/Button';
import Config from '../../config';
import StyledText from '../../components/StyledText'

const VerificationComponent = ({ className }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const baseClassName = clsx("verificationComponent", className);

  const validateEmail = async (_, email) => {
    const expression = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email) {
      return Promise.reject(new Error('Please input your email.'));
    }
    if (!expression.test(String(email).toLowerCase())) {
      return Promise.reject(new Error('Invalid email address.'));
    }
    return Promise.resolve();
  };
  
  const { uniqueKey } = useParams();
  const getStatus = async (response) => {
    let status = '';
    if (response) {
      if (
        response === 'The share link has already expired'
        || response === 'The incoming token has expired' || response === 'The share Link already expired'
      ) {
        status = 'expired';
      } else if (
        response === 'This email is not permitted to access the portal' || response === 'email is not permitted to access the portal'
        || response === 'confirmEamil is Missing'
      ) {
        status = 'inValid';
      } else {
        status = 'confirmed';
      }
      navigate(`/share/confirmation?type=${status}`);
    }
  };

  const onFinish = async (values) => {
    const data = {
      type: 'ConfirmShareLink',
      uniqueKey,
      emailId: values?.invitedUser,
    };

    const url = Config.dev.url.confirmShareVerificationLink;
    window.sessionStorage.setItem('verificationEmail', values?.invitedUser);

    try {
      const response = await axios.post(url, data, {
        headers: { Authorization: localStorage.getItem('id_Token') },
      });
      await getStatus(response?.data?.message);
    } catch (error) {
      await getStatus(error?.response?.data?.message);
    }
  };

  const intl = useIntl();
  return (
    <div className={baseClassName}>
      <div>
        <StyledText as="p" variant="H1a" className="signUp">
          {intl.formatMessage({ id: 'verify_your_email' })}
        </StyledText>
      </div>
      <div className='contentContainer'>
        <div>
          <StyledText as="p" variant="B1" className="signUp">
            {intl.formatMessage({ id: 'please_verify_your_email_to_receive_a_magic_link' })}
          </StyledText>
        </div>
        <Form onFinish={onFinish} onFinishFailed={({ errorFields }) => {
          form.scrollToField(errorFields[0]?.name);
        }} form={form} >
          <div>
            <Form.Item
              name="invitedUser"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: 'please_input_your_email_id',
                  }),
                },
                { validator: validateEmail }
              ]}
            >
              <Input
                placeholder={intl.formatMessage({ id: 'enter_email_address' })}
                type="text"
                className=""
              />
            </Form.Item>
          </div>
          <div>
            <Button variant="primary" htmlType="submit">
              {intl.formatMessage({ id: 'verify' })}
            </Button>
          </div>
        </Form>
        <div>
          <StyledText as="p" variant="B1" className="signUp">
            {intl.formatMessage({ id: 'please_note_this_email_address_needs_to_match_the_address' })}
          </StyledText>
        </div>
      </div>
    </div>
  );
};

const StyledVerificationComponent = styled(VerificationComponent)`
  &.verificationComponent {
    text-align: center;
    margin-top: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    height: 50vh;
    .contentContainer{
      display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}
}
`;

export default StyledVerificationComponent;
